import {
  Grid,
  CardHeader,
  CardContent,
  Box,
  TextField,
  IconButton,
  MenuItem,
  FormHelperText,
  Typography,
  Divider,
  Paper,
  Chip,
  Alert,
  Stack,
  Card,
  CardContent as CardContentInner,
} from "@mui/material";
import { Form, FormikProvider, useFormik, FieldArray } from "formik";
import React, { useState, useEffect, useCallback, useRef } from "react";
import {
  AddCircle,
  RemoveCircle,
  SportsSoccer,
  Business,
  Schedule,
  AttachMoney,
  Group,
  Settings,
  EmojiEvents,
} from "@mui/icons-material";
import {
  contestServices,
  gameManagementApi,
  LeagueManagementService,
  getLeagueRoundsWithMatches,
} from "../../services/AllServices";
import { useNavigate, useParams } from "react-router-dom";
import errorHandler from "../../utils/errorHandler";
import { formatPrice } from "../../utils/formatNumber";
import LoadingButton from "@mui/lab/LoadingButton";
import { ContestSchema } from "../../utils/Schema";
import CardLayout from "../../layouts/CardLayout";
import { toast } from "react-toastify";
import { DatePicker } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import "./MatchSelection.css";
const ViewAddEditContestManagement = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const [data, setData] = useState();
  const [leagues, setLeagues] = useState([]);
  const [country, setCountry] = useState([]);
  const [loading, setLoading] = useState(false);
  const [percentageErrorIndex, setPercentageErrorIndex] = useState(null);
  const [matchCount, setMatchCount] = useState(0);
  const [positionActionsMap, setPositionActionsMap] = useState({});
  // const [gameWeeksMap, setGameWeeksMap] = useState({});
  const [gameWeekIdMap, setGameWeekIdMap] = useState({});
  const [validationContext, setValidationContext] = useState({
    gameType: "",
    numberOfWinners: "",
  });

  const [availableMatches, setAvailableMatches] = useState([]);
  const [selectedMatches, setSelectedMatches] = useState({
    daily: [],
    weekly: {},
    monthly: {},
    season: {},
  });
  const [activeWeekTab, setActiveWeekTab] = useState(1);
  const [currentWeekPage, setCurrentWeekPage] = useState(1);
  const [weeksPerPage] = useState(12);
  const [isFetchingMatches, setIsFetchingMatches] = useState(false);
  const [rounds, setRounds] = useState([]);

  const lastFetchRef = useRef({
    timeRange: "",
    startTime: "",
    endTime: "",
    leagueId: "",
  });

  const debounceTimerRef = useRef(null);

  const fetchCountry = async () => {
    try {
      const response = await LeagueManagementService.getCountry();

      if (response.status == 200) {
        setCountry(response?.data?.data || []);
      }
    } catch (error) {
      toast.error(
        error?.response?.data?.message || "Error in fetching Country."
      );
    }
  };
  useEffect(() => {
    fetchCountry();
  }, []);

  const fetchContestData = useCallback(async () => {
    if (id) {
      setLoading(true);
      try {
        const response = await contestServices.getById({ id });
        const contestData = response?.data?.data;
        setData(contestData);

        // Map saved matches to selectedMatches state for UI selection
        if (contestData?.gameWeeks) {
          const selected = {
            daily: [],
            weekly: {},
            monthly: {},
            season: {},
          };

          contestData.gameWeeks.forEach((week) => {
            const matchIds = week?.matches?.map((m) => m?.matchId) || [];
            const weekKey = week.gameWeekId || week._id || week.id;

            if (contestData.gameDuration.type === "daily") {
              selected.daily = selected.daily.concat(matchIds);
            } else if (contestData.gameDuration.type === "week") {
              // For weekly, we need to map to the week key format used in the UI
              const weekNumber = Object.keys(selected.weekly).length + 1;
              const uiWeekKey = `week${weekNumber}`;
              selected.weekly[uiWeekKey] = matchIds;

              // Also update the gameWeekIdMap for this week
              setGameWeekIdMap((prev) => ({
                ...prev,
                [uiWeekKey]: weekKey,
              }));
            } else if (contestData.gameDuration.type === "monthly") {
              const weekNumber = Object.keys(selected.monthly).length + 1;
              const uiWeekKey = `week${weekNumber}`;
              selected.monthly[uiWeekKey] = matchIds;

              setGameWeekIdMap((prev) => ({
                ...prev,
                [uiWeekKey]: weekKey,
              }));
            } else if (contestData.gameDuration.type === "season") {
              const weekNumber = Object.keys(selected.season).length + 1;
              const uiWeekKey = `week${weekNumber}`;
              selected.season[uiWeekKey] = matchIds;

              setGameWeekIdMap((prev) => ({
                ...prev,
                [uiWeekKey]: weekKey,
              }));
            }
          });

          setSelectedMatches(selected);
        }
      } catch (error) {
        errorHandler(error);
      } finally {
        setLoading(false);
      }
    }

    fetchCountry();
  }, [id]);

  useEffect(() => {
    if (data?.gameWeeks) {
      const map = {};
      data.gameWeeks.forEach((week, idx) => {
        const key = `week${idx + 1}`;
        map[key] = week.gameWeekId || week._id || week.id || key;
      });
      setGameWeekIdMap(map);

      if (data.gameDuration?.type !== "daily" && data.gameWeeks.length > 0) {
        const selected = {
          daily: [],
          weekly: {},
          monthly: {},
          season: {},
        };

        data.gameWeeks.forEach((week, idx) => {
          const matchIds = week?.matches?.map((m) => m?.matchId) || [];
          const weekKey = `week${idx + 1}`;

          if (data.gameDuration.type === "week") {
            selected.weekly[weekKey] = matchIds;
          } else if (data.gameDuration.type === "monthly") {
            selected.monthly[weekKey] = matchIds;
          } else if (data.gameDuration.type === "season") {
            selected.season[weekKey] = matchIds;
          }
        });

        setSelectedMatches((prev) => ({ ...prev, ...selected }));
      }
    }
  }, [data]);

  const handleTimeRangeChange = (event) => {
    const value = event.target.value;
    let durationType = "";
    if (value === "daily") {
      durationType = "daily";
    } else if (value === "week") {
      durationType = "week";
    } else if (value === "monthly") {
      durationType = "monthly";
    } else if (value === "season") {
      durationType = "season";
    }

    // Reset selected matches and available matches
    setSelectedMatches({
      daily: [],
      weekly: {},
      monthly: {},
      season: {},
    });

    setAvailableMatches([]);

    // Reset week-related states
    setActiveWeekTab(1);
    setCurrentWeekPage(1);

    formik.setValues({
      ...formik.values,
      timeRange: value,
      durationType,
      startTime: "",
      endTime: "",
    });

    if (value === "daily" && formik.values.leagueId) {
    }
  };

  const callCountMatchTimeWise = async () => {
    try {
      if (!formik.values.startTime || !formik.values.endTime) {
        return;
      }

      const startDate = new Date(formik.values.startTime);
      const endDate = new Date(formik.values.endTime);

      if (isNaN(startDate.getTime()) || isNaN(endDate.getTime())) {
        return;
      }

      const payload = {
        leagueId: formik.values.leagueId,
        startTime: formik.values.startTime,
        endTime: formik.values.endTime,
      };

      const response = await contestServices.countMatchTimeWise(payload);
      if (response?.data?.data?.matchCount) {
        setMatchCount(response.data.data.matchCount);
      }
    } catch (error) {
      console.error("Error fetching match count:", error);
      setMatchCount(0);
    }
  };

  const getRemainingPercentage = () => {
    if (formik?.values?.gameType !== "playForFun") {
      const total = formik?.values?.payoutStructure.reduce((sum, item) => {
        const percent = parseFloat(item.percentage);
        return sum + (isNaN(percent) ? 0 : percent);
      }, 0);

      const remaining = 100 - total;
      return isNaN(remaining) ? 0 : remaining;
    }
    return 0;
  };

  const getMatchesByTimeRange = useCallback((timeRange, startDate, endDate) => {
    if (!startDate || !endDate) return [];
    return [];
  }, []);

  const groupMatchesByWeek = (matches, startDate, endDate) => {
    if (!startDate || !endDate || !matches || matches.length === 0) return {};

    let start, end;

    try {
      if (typeof startDate === "string") {
        if (startDate.includes("T")) {
          start = new Date(startDate);
        } else {
          start = new Date(startDate);
        }
      } else if (startDate instanceof Date) {
        start = new Date(startDate);
      } else {
        console.error(
          "Invalid start date format in groupMatchesByWeek:",
          startDate
        );
        return {};
      }

      if (typeof endDate === "string") {
        if (endDate.includes("T")) {
          end = new Date(endDate);
        } else {
          end = new Date(endDate);
        }
      } else if (endDate instanceof Date) {
        end = new Date(endDate);
      } else {
        console.error(
          "Invalid end date format in groupMatchesByWeek:",
          endDate
        );
        return {};
      }

      // Validate dates
      if (isNaN(start.getTime()) || isNaN(end.getTime())) {
        console.error("Invalid dates in groupMatchesByWeek:", {
          startDate,
          endDate,
        });
        return {};
      }
    } catch (error) {
      console.error("Error processing dates in groupMatchesByWeek:", error);
      return {};
    }

    const weeks = {};
    let currentWeek = 1;

    // First, filter matches to only include those within the exact date range
    const filteredMatches = matches.filter((match) => {
      try {
        const matchDate = new Date(match.startingAt);
        if (isNaN(matchDate.getTime())) {
          console.warn("Invalid match date:", match.startingAt);
          return false;
        }
        // Only include matches that fall within the exact selected date range
        // Use date comparison by setting time to start of day for accurate comparison
        const matchDateStartOfDay = new Date(matchDate);
        matchDateStartOfDay.setHours(0, 0, 0, 0);

        const startStartOfDay = new Date(start);
        startStartOfDay.setHours(0, 0, 0, 0);

        const endStartOfDay = new Date(end);
        endStartOfDay.setHours(0, 0, 0, 0);

        const isInRange =
          matchDateStartOfDay >= startStartOfDay &&
          matchDateStartOfDay <= endStartOfDay;

        return isInRange;
      } catch (error) {
        console.warn("Error processing match date:", error);
        return false;
      }
    });

    const totalDays = Math.ceil((end - start) / (1000 * 60 * 60 * 24)) + 1;

    if (totalDays <= 7) {
      const weekKey = `week1`;
      weeks[weekKey] = {
        startDate: new Date(start),
        endDate: new Date(end),
        matches: filteredMatches,
      };
    } else {
      // If range is more than 7 days, create multiple weeks
      for (let d = new Date(start); d <= end; d.setDate(d.getDate() + 7)) {
        const weekEnd = new Date(d);
        weekEnd.setDate(d.getDate() + 6);

        // Ensure weekEnd doesn't exceed the actual end date
        if (weekEnd > end) {
          weekEnd.setTime(end.getTime());
        }

        const weekMatches = filteredMatches.filter((match) => {
          try {
            const matchDate = new Date(match.startingAt);
            if (isNaN(matchDate.getTime())) {
              console.warn("Invalid match date:", match.startingAt);
              return false;
            }

            // Use start of day comparison for week assignment as well
            const matchDateStartOfDay = new Date(matchDate);
            matchDateStartOfDay.setHours(0, 0, 0, 0);

            const weekStartStartOfDay = new Date(d);
            weekStartStartOfDay.setHours(0, 0, 0, 0);

            const weekEndStartOfDay = new Date(weekEnd);
            weekEndStartOfDay.setHours(0, 0, 0, 0);

            const isInWeek =
              matchDateStartOfDay >= weekStartStartOfDay &&
              matchDateStartOfDay <= weekEndStartOfDay;

            return isInWeek;
          } catch (error) {
            console.warn("Error processing match date:", error);
            return false;
          }
        });

        // Always create weeks regardless of whether they have matches
        const weekKey = `week${currentWeek}`;
        weeks[weekKey] = {
          startDate: new Date(d),
          endDate: weekEnd,
          matches: weekMatches || [],
        };
        currentWeek++;
      }
    }
    return weeks;
  };

  const fetchMatchesByDate = useCallback(
    async (timeRange, startDate, endDate, leagueID) => {
      if (!startDate || !endDate || !leagueID) {
        return [];
      }

      const formatTimeToUTC = (dateString, isStartTime = true) => {
        if (!dateString) return null;
        const parsedDate = new Date(dateString);
        if (isNaN(parsedDate.getTime())) {
          return null;
        }
        const utcDate = new Date(parsedDate);
        if (isStartTime) {
          utcDate.setHours(0, 0, 0, 0);
        } else {
          utcDate.setHours(23, 59, 59, 999);
        }
        return utcDate.toISOString();
      };

      const payload = {
        leagueId: String(leagueID),
        startDate: formatTimeToUTC(startDate, true),
        endDate: formatTimeToUTC(endDate, false),
      };

      try {
        const response = await getLeagueRoundsWithMatches.getLeagueRounds(payload);
        const fetchedRounds = response.data.data.rounds || [];
        setRounds(fetchedRounds);
        const allMatches = fetchedRounds.flatMap((round) => round.matches || []);
        return fetchedRounds;
      } catch (err) {
        console.error("Error fetching matches", err);
        return [];
      }
    },
    []
  );

  const handleMatchSelection = (_id, timeRange, weekKey = null) => {
    const newState = { ...selectedMatches };

    if (timeRange === "daily") {
      if (newState.daily.includes(_id)) {
        newState.daily = newState.daily.filter((id) => id !== _id);
      } else {
        newState.daily.push(_id);
      }
    } else {
      let stateKey;
      if (timeRange === "week") stateKey = "weekly";
      else if (timeRange === "monthly") stateKey = "monthly";
      else if (timeRange === "season") stateKey = "season";
      else stateKey = timeRange;

      if (!newState[stateKey]) {
        newState[stateKey] = {};
      }
      if (!newState[stateKey][weekKey]) {
        newState[stateKey][weekKey] = [];
      }

      if (newState[stateKey][weekKey].includes(_id)) {
        newState[stateKey][weekKey] = newState[stateKey][weekKey].filter(
          (id) => id !== _id
        );
      } else {
        newState[stateKey][weekKey].push(_id);
      }
    }

    setSelectedMatches(newState);
  };

  const handleSelectAllMatchesInWeek = (timeRange, weekKey) => {
    const newState = { ...selectedMatches };
    let stateKey;

    if (timeRange === "week") stateKey = "weekly";
    else if (timeRange === "monthly") stateKey = "monthly";
    else if (timeRange === "season") stateKey = "season";
    else return;

    if (!newState[stateKey]) {
      newState[stateKey] = {};
    }

    const round = availableMatches.find(r => r.uiKey === weekKey);
    const weekMatches = round?.matches || [];

    newState[stateKey][weekKey] = weekMatches.map((match) => match._id);

    setSelectedMatches(newState);
  };

  const handleDeselectAllMatchesInWeek = (timeRange, weekKey) => {
    const newState = { ...selectedMatches };
    let stateKey;

    if (timeRange === "week") stateKey = "weekly";
    else if (timeRange === "monthly") stateKey = "monthly";
    else if (timeRange === "season") stateKey = "season";
    else return;

    if (newState[stateKey] && newState[stateKey][weekKey]) {
      newState[stateKey][weekKey] = [];
      setSelectedMatches(newState);
    }
  };

  // Function to select all matches across all weeks for a time range
  const handleSelectAllMatchesInTimeRange = (timeRange) => {
    const newState = { ...selectedMatches };
    let stateKey;

    if (timeRange === "week") stateKey = "weekly";
    else if (timeRange === "monthly") stateKey = "monthly";
    else if (timeRange === "season") stateKey = "season";
    else return;

    if (!newState[stateKey]) {
      newState[stateKey] = {};
    }

    // Select all matches in all rounds
    availableMatches.forEach((round) => {
      const weekMatches = round?.matches || [];
      newState[stateKey][round.uiKey] = weekMatches.map((match) => match._id);
    });

    setSelectedMatches(newState);
  };

  // Function to deselect all matches across all weeks for a time range
  const handleDeselectAllMatchesInTimeRange = (timeRange) => {
    const newState = { ...selectedMatches };
    let stateKey;

    if (timeRange === "week") stateKey = "weekly";
    else if (timeRange === "monthly") stateKey = "monthly";
    else if (timeRange === "season") stateKey = "season";
    else return;

    if (newState[stateKey]) {
      newState[stateKey] = {};
      setSelectedMatches(newState);
    }
  };

  const isMatchSelected = (_id, timeRange, weekKey = null) => {
    if (timeRange === "daily") {
      return selectedMatches.daily.includes(_id);
    } else if (weekKey) {
      let stateKey;
      if (timeRange === "week") stateKey = "weekly";
      else if (timeRange === "monthly") stateKey = "monthly";
      else if (timeRange === "season") stateKey = "season";
      else stateKey = timeRange;

      const isSelected =
        selectedMatches[stateKey]?.[weekKey]?.includes(_id) || false;
      return isSelected;
    }
    return false;
  };

  const getCurrentWeekPage = (weekKeys) => {
    const totalPages = Math.ceil(weekKeys.length / weeksPerPage);
    const startIndex = (currentWeekPage - 1) * weeksPerPage;
    const endIndex = startIndex + weeksPerPage;
    return weekKeys.slice(startIndex, endIndex);
  };

  const handleWeekPageChange = (newPage) => {
    setCurrentWeekPage(newPage);
    setActiveWeekTab(1);
  };

  const handleQuickWeekSelect = (weekKey) => {
    const weekKeys = availableMatches.map((r) => r.uiKey);
    const weekIndex = weekKeys.indexOf(weekKey);
    const pageNumber = Math.floor(weekIndex / weeksPerPage) + 1;
    setCurrentWeekPage(pageNumber);

    const globalWeekNumber = weekIndex + 1;
    setActiveWeekTab(globalWeekNumber);
  };

  const formik = useFormik({
    enableReinitialize: true,
    validationSchema: ContestSchema,
    validateOnBlur: true,
    validateOnChange: true,
    context: validationContext,
    initialValues: {
      contestName: data?.contestName || "",
      leagueId: data?.leagueId?._id || "",
      country: data?.countryId || "",
      type: data?.type || "",
      contestType: {
        type: data?.contestType?.type || "",
        playerPosition: data?.contestType?.playerPosition || "",
        negativeType: data?.contestType?.negativeType || "",
        playerActionType: data?.contestType?.actionType || "",
      },

      gameType: data?.gameType || "",
      numberOfWinners: data?.numberOfWinners || "",
      payoutStructure: data?.payoutStructure || [
        { startPosition: "", endPosition: "", percentage: "" },
      ],
      entryFee: data?.entryFee || "",
      contestCommission: data?.contestCommission,
      timeRange: data?.gameDuration?.type || "",
      startTime: data?.gameDuration?.startTime || "",
      endTime: data?.gameDuration?.endTime || "",
      durationType: data?.gameDuration?.type || "",
      totalRoomSize: data?.roomSize?.totalRoomSize || "",
      roomType: data?.roomSize?.type || "",
    },
    onSubmit: async (values) => {
      if (formik.values.gameType !== "playForFun") {
        const remainingPercentage = getRemainingPercentage();
        if (remainingPercentage !== 0) {
          toast.error(
            `Total payout percentage must equal 100%. Remaining percentage: ${remainingPercentage}%`
          );
          return;
        }
      }

      if (
        !formik.values.timeRange ||
        !formik.values.startTime ||
        !formik.values.endTime
      ) {
        toast.error("Please select time range and dates");
        return;
      }

      let hasSelectedMatches = false;
      if (formik.values.timeRange === "daily") {
        hasSelectedMatches = selectedMatches.daily.length > 0;
      } else if (formik.values.timeRange === "week") {
        hasSelectedMatches = Object.values(selectedMatches.weekly).some(
          (weekMatches) => weekMatches.length > 0
        );
      } else if (formik.values.timeRange === "monthly") {
        hasSelectedMatches = Object.values(selectedMatches.monthly).some(
          (weekMatches) => weekMatches.length > 0
        );
      } else if (formik.values.timeRange === "season") {
        hasSelectedMatches = Object.values(selectedMatches.season).some(
          (weekMatches) => weekMatches.length > 0
        );
      }

      if (!hasSelectedMatches) {
        toast.error("Please select at least one match");
        return;
      }

      // setLoading(true);
      try {
        const formatTimeToUTC = (dateString, isStartTime = true) => {
          if (!dateString) return null;

          const date = new Date(dateString);
          if (isNaN(date.getTime())) {
            console.error(
              "Invalid date passed to formatTimeToUTC:",
              dateString
            );
            return null;
          }

          if (isStartTime) {
            date.setHours(0, 0, 1, 0);
          } else {
            date.setHours(23, 59, 59, 999);
          }

          return date.toISOString();
        };

        let matchesPayload = {};

        if (formik.values.timeRange === "daily") {
          const weekPayload = {
            matches: selectedMatches.daily,
            startDate: formatTimeToUTC(formik.values.startTime, true),
            endDate: formatTimeToUTC(formik.values.endTime, false),
          };
          // Add roundId from the first round if available
          // if (rounds && rounds.length > 0) {
          //   weekPayload.roundId = rounds[0].roundId || rounds[0]._id;
          // }

          // Only add gameWeekId when editing (id exists)
          if (id && gameWeekIdMap["week1"]) {
            weekPayload.gameWeekId = gameWeekIdMap["week1"];
          }

          matchesPayload = {
            gameweek: {
              week1: weekPayload,
            },
          };
        } else if (
          ["week", "monthly", "season"].includes(formik.values.timeRange)
        ) {
          let stateKey;
          if (formik.values.timeRange === "week") stateKey = "weekly";
          else if (formik.values.timeRange === "monthly") stateKey = "monthly";
          else if (formik.values.timeRange === "season") stateKey = "season";
          else stateKey = formik.values.timeRange;

          matchesPayload = {
            gameweek: availableMatches.reduce((acc, round) => {
              const weekKey = round.uiKey;
              const selectedMatchesForRound =
                selectedMatches[stateKey]?.[weekKey] || [];

              const roundPayload = {
                matches: selectedMatchesForRound,
                startDate: formatTimeToUTC(round.startDate.toISOString(), true),
                endDate: formatTimeToUTC(round.endDate.toISOString(), false),
                // roundId: round.roundId || round._id,
              };

              if (id && gameWeekIdMap[weekKey]) {
                roundPayload.gameWeekId = gameWeekIdMap[weekKey];
              }

              acc[weekKey] = roundPayload;

              return acc;
            }, {}),
          };
        }

        const contestName = values.contestName ? values.contestName.trim() : "";

        const position = values.contestType?.playerPosition || "";
        const action =
          values.contestType?.actionType ||
          values.contestType?.playerActionType ||
          "";
        let actionEventId = null;
        if (position && positionActionsMap && positionActionsMap[position]) {
          const found = positionActionsMap[position].find(
            (a) => a.value === action
          );
          actionEventId = found ? found.actionEventId : null;
        }

        const payload = {
          id: id || undefined,
          contestName,
          leagueId: values.leagueId,
          type: values.type,
          contestType: {
            type: values.contestType.type,
            ...(values.contestType.type === "position" && {
              playerPosition: values.contestType.playerPosition,
            }),
            ...(values.contestType.type === "negative-point" && {
              negativeType: values.contestType.negativeType,
            }),
            ...(values.contestType.type === "action" && {
              playerPosition: position,
              actionType: values.contestType.playerActionType,
              actionEventId,
            }),
          },
          gameType: values.gameType,
          roomType: values.roomType,
          ...(values.roomType === "limited" && {
            totalRoomSize: values.totalRoomSize,
          }),
          numberOfWinners: values.numberOfWinners,
          ...(values.gameType !== "playForFun" && {
            payoutStructure: values.payoutStructure,
          }),
          timeRange: values.timeRange,
          startTime: formatTimeToUTC(values.startTime, true),
          endTime: formatTimeToUTC(values.endTime, false),
          durationType: values.durationType,
          countryId: values.country,
          ...(values.gameType !== "playForFun" && {
            entryFee: values.entryFee,
          }),
          contestCommission: values.contestCommission,
          selectedMatches: matchesPayload,
        };

        const response = id
          ? await contestServices.edit(payload)
          : await contestServices.add(payload);
        toast.success(response?.data?.message, { toastId: "success" });
        navigate(-1);
      } catch (error) {
        console.error("Submission error: ", error);
        toast.error("Error submitting contest. Check console.");
        setLoading(false);
      }
    },
  });

  useEffect(() => {
    if (formik.values.type === "head-to-head") {
      formik.setValues((prevValues) => ({
        ...prevValues,
        roomType: "limited",
        totalRoomSize: "2",
        numberOfWinners: "1",
        payoutStructure: [
          { startPosition: "1", endPosition: "1", percentage: "100" },
        ],
      }));
    }
  }, [formik.values.type]);

  useEffect(() => {
    setValidationContext({
      gameType: formik.values.gameType,
      numberOfWinners: formik.values.numberOfWinners,
    });
  }, [formik.values.gameType, formik.values.numberOfWinners]);

  const fetchLeagues = useCallback(async () => {
    try {
      const payload = {
        countryId: [formik.values.country] || [],
      };
      const response = await contestServices?.getAllLeagues(payload);
      setLeagues(response?.data?.data?.leagues || []);
    } catch (error) {
      errorHandler(error);
    }
  }, [formik.values.country]);

  useEffect(() => {
    fetchContestData();
    fetchLeagues();
  }, [fetchContestData, fetchLeagues, id]);

  useEffect(() => {
    const fatchAllGames = async () => {
      try {
        const payload = {
          searchItem: "",
          status: 1,
          pageNumber: 1,
          pageSize: 100,
        };
        const response = await gameManagementApi.getAllGames(payload);
        const result = response?.data?.data?.result;
        const positionGame = result.find((item) => item?.type === "position");
        const positions = positionGame?.rules?.[0]?.allowedPositions || [];
        const negativePoint = result.find(
          (item) => item?.type === "negative-point"
        );
        const NegativeValue = negativePoint?.rules?.[0]?.allowedPoints || [];
        const action = result.find((item) => item?.type === "action");
        const actionValue = action?.rules?.[0]?.allowedPositions || [];

        const formattedData = {};
        actionValue.forEach((position) => {
          formattedData[position.value] = position.allowedAction.map(
            (action) => ({
              value: action.value,
              label: action.title,
              actionEventId: action.actionEventId,
            })
          );
        });
        setPositionActionsMap(formattedData);
      } catch (error) {
        console.error("Error fetching contests:", error);
      }
    };
    fatchAllGames();
  }, []);

  useEffect(() => {
    if (isFetchingMatches) {
      return;
    }

    const fetchAndSetMatches = async () => {
      if (
        formik.values.timeRange &&
        formik.values.startTime &&
        formik.values.endTime &&
        formik.values.leagueId &&
        formik.values.startTime !== "" &&
        formik.values.endTime !== ""
      ) {
        const currentFetch = {
          timeRange: formik.values.timeRange,
          startTime: formik.values.startTime,
          endTime: formik.values.endTime,
          leagueId: formik.values.leagueId,
        };

        if (
          lastFetchRef.current.timeRange === currentFetch.timeRange &&
          lastFetchRef.current.startTime === currentFetch.startTime &&
          lastFetchRef.current.endTime === currentFetch.endTime &&
          lastFetchRef.current.leagueId === currentFetch.leagueId
        ) {
          return;
        }

        lastFetchRef.current = currentFetch;

        setIsFetchingMatches(true);

        try {
          const startDate = new Date(formik.values.startTime);
          const endDate = new Date(formik.values.endTime);

          if (isNaN(startDate.getTime()) || isNaN(endDate.getTime())) {
            return;
          }

          const fetchedRounds = await fetchMatchesByDate(
            formik.values.timeRange,
            formik.values.startTime,
            formik.values.endTime,
            formik.values.leagueId
          );

          if (formik.values.timeRange === "daily") {
            const allMatches = fetchedRounds.flatMap((round) =>
              (round.matches || []).map((match) => ({
                ...match,
                _id: match.matchId || match._id,
                status:
                  match.state === "Not Started"
                    ? 1
                    : match.state === "Live"
                    ? 2
                    : 3,
                liveStats: match.state === "Live" ? { status: "live" } : null,
              }))
            );
            setAvailableMatches(allMatches);
            if (!id) {
              const dailyMatchIds = allMatches.map((match) => match._id);
              setSelectedMatches((prev) => ({
                ...prev,
                daily: dailyMatchIds,
              }));
            }
          } else {
            const processedRounds = fetchedRounds
              .map((round, index) => ({
                ...round,
                uiKey: `week${index + 1}`,
                roundNumber: index + 1,
                startDate: new Date(round.startDate),
                endDate: new Date(round.endDate),
                matches: (round.matches || []).map((match) => ({
                  ...match,
                  _id: match.matchId || match._id,
                  status:
                    match.state === "Not Started"
                      ? 1
                      : match.state === "Live"
                      ? 2
                      : 3,
                  liveStats: match.state === "Live" ? { status: "live" } : null,
                })),
              }))
              .filter((r) => r.matches.length > 0);
            setAvailableMatches(processedRounds);
            if (!id) {
              let stateKey;
              if (formik.values.timeRange === "week") stateKey = "weekly";
              else if (formik.values.timeRange === "monthly") stateKey = "monthly";
              else if (formik.values.timeRange === "season") stateKey = "season";
              const selectedByRound = {};
              processedRounds.forEach((round) => {
                selectedByRound[round.uiKey] = round.matches.map((m) => m._id);
              });
              setSelectedMatches((prev) => ({
                ...prev,
                [stateKey]: selectedByRound,
              }));
            }
          }
          setActiveWeekTab(1);
        } catch (error) {
          console.error("Error in fetchAndSetMatches:", error);
        } finally {
          setIsFetchingMatches(false);
        }
      }
    };

    if (
      formik.values.timeRange &&
      formik.values.startTime &&
      formik.values.endTime &&
      formik.values.leagueId
    ) {
      if (debounceTimerRef.current) {
        clearTimeout(debounceTimerRef.current);
      }

      debounceTimerRef.current = setTimeout(() => {
        fetchAndSetMatches();
      }, 300);
    }

    return () => {
      setIsFetchingMatches(false);
      if (debounceTimerRef.current) {
        clearTimeout(debounceTimerRef.current);
      }
    };
  }, [
    formik.values.timeRange,
    formik.values.startTime,
    formik.values.endTime,
    formik.values.leagueId,
    isFetchingMatches,
    id,
    selectedMatches,
  ]);

  return (
    <Box>
      <CardLayout>
        <CardHeader
          title={
            <Box display="flex" alignItems="center" gap={2}>
              <SportsSoccer sx={{ color: "primary.main", fontSize: 28 }} />
              <Typography variant="h4" component="h1">
                View Contest Details
              </Typography>
            </Box>
          }
          subheader="View contest settings and rules for your fantasy sports competition"
        />
        <CardContent>
          <FormikProvider value={formik}>
            <Form autoComplete="off" noValidate onSubmit={formik.handleSubmit}>
              <Stack spacing={4}>
                <Paper
                  elevation={0}
                  sx={{
                    p: 3,
                    border: "1px solid",
                    borderColor: "divider",
                    borderRadius: 2,
                  }}
                >
                  <Box display="flex" alignItems="center" gap={2} mb={3}>
                    <Business sx={{ color: "primary.main" }} />
                    <Typography variant="h6" fontWeight="600">
                      Basic Information
                    </Typography>
                  </Box>

                  <Grid container spacing={3}>
                    <Grid item xs={12}>
                      <TextField
                        fullWidth
                        label="Contest Name"
                        name="contestName"
                        value={formik.values.contestName}
                        onChange={formik.handleChange}
                        error={
                          formik.touched.contestName &&
                          Boolean(formik.errors.contestName)
                        }
                        helperText={
                          formik.touched.contestName &&
                          formik.errors.contestName
                        }
                        placeholder="Enter contest name"
                        size="medium"
                        disabled={true}
                      />
                    </Grid>

                    <Grid item xs={12} md={6}>
                      <TextField
                        select
                        fullWidth
                        label="Select Country"
                        name="country"
                        value={formik.values.country}
                        onChange={formik.handleChange}
                        error={
                          formik.touched.country &&
                          Boolean(formik.errors.country)
                        }
                        helperText={
                          formik.touched.country && formik.errors.country
                        }
                        disabled={true}
                        size="medium"
                      >
                        {country?.map((league) => (
                          <MenuItem
                            key={league?.countryId}
                            value={league?.countryId}
                          >
                            {league?.country}
                          </MenuItem>
                        ))}
                      </TextField>
                    </Grid>

                    <Grid item xs={12} md={6}>
                      <TextField
                        select
                        fullWidth
                        label="League"
                        name="leagueId"
                        value={leagues.length > 0 ? formik.values.leagueId : ""}
                        onChange={(e) => {
                          formik.setFieldValue("leagueId", e.target.value);

                          if (
                            formik.values.timeRange === "daily" &&
                            e.target.value &&
                            formik.values.startTime &&
                            formik.values.endTime
                          ) {
                            setTimeout(() => callCountMatchTimeWise(), 100);
                          }
                        }}
                        error={
                          formik.touched.leagueId &&
                          Boolean(formik.errors.leagueId)
                        }
                        helperText={
                          formik.touched.leagueId && formik.errors.leagueId
                        }
                        disabled={true}
                        size="medium"
                      >
                        {leagues?.map((league) => (
                          <MenuItem key={league._id} value={league._id}>
                            {league.name}
                          </MenuItem>
                        ))}
                      </TextField>
                    </Grid>
                  </Grid>
                </Paper>

                {/* Contest Configuration */}
                <Paper
                  elevation={0}
                  sx={{
                    p: 3,
                    border: "1px solid",
                    borderColor: "divider",
                    borderRadius: 2,
                  }}
                >
                  <Box display="flex" alignItems="center" gap={2} mb={3}>
                    <Settings sx={{ color: "primary.main" }} />
                    <Typography variant="h6" fontWeight="600">
                      Contest Configuration
                    </Typography>
                  </Box>

                  <Grid container spacing={3}>
                    <Grid item xs={12} md={6}>
                      <TextField
                        select
                        fullWidth
                        label="Type"
                        name="type"
                        value={formik.values.type}
                        onChange={formik.handleChange}
                        error={
                          formik.touched.type && Boolean(formik.errors.type)
                        }
                        helperText={formik.touched.type && formik.errors.type}
                        size="medium"
                        disabled={true}
                      >
                        <MenuItem value="public">Public</MenuItem>
                        <MenuItem value="private">Private</MenuItem>
                      </TextField>
                    </Grid>

                    <Grid item xs={12} md={6}>
                      <TextField
                        select
                        fullWidth
                        label="Contest Type"
                        name="gameType"
                        value={formik.values.gameType}
                        onChange={formik.handleChange}
                        error={
                          formik.touched.gameType &&
                          Boolean(formik.errors.gameType)
                        }
                        helperText={
                          formik.touched.gameType && formik.errors.gameType
                        }
                        size="medium"
                        disabled={true}
                      >
                        <MenuItem value="playForMoney">Play For Money</MenuItem>
                        <MenuItem value="playForFun">Play For Fun</MenuItem>
                      </TextField>
                    </Grid>

                    <Grid item xs={12} md={6}>
                      <TextField
                        select
                        fullWidth
                        label="Room Type"
                        name="roomType"
                        disabled={true}
                        value={
                          formik.values.type == "head-to-head"
                            ? "limited"
                            : formik.values.roomType
                        }
                        onChange={(e) => {
                          const value = e.target.value;
                          formik.setValues({
                            ...formik.values,
                            roomType: value,
                            totalRoomSize:
                              value === "limited"
                                ? formik.values.totalRoomSize
                                : formik.values.totalRoomSize,
                          });
                        }}
                        error={
                          formik.touched.roomType &&
                          Boolean(formik.errors.roomType)
                        }
                        helperText={
                          formik.touched.roomType && formik.errors.roomType
                        }
                        size="medium"
                      >
                        <MenuItem value="limited">Limited</MenuItem>
                        <MenuItem value="unlimited">Unlimited</MenuItem>
                      </TextField>
                    </Grid>

                    {formik.values.roomType === "limited" && (
                      <Grid item xs={12} md={6}>
                        <TextField
                          fullWidth
                          label="Room Size"
                          name="totalRoomSize"
                          disabled={true}
                          value={
                            formik.values.type == "head-to-head"
                              ? 2
                              : formik.values.totalRoomSize
                          }
                          onChange={(e) => {
                            const value = e.target.value
                              .replace(/[^0-9]/g, "")
                              .slice(0, 9);
                            formik.setFieldValue("totalRoomSize", value);
                          }}
                          error={
                            formik.touched.totalRoomSize &&
                            Boolean(formik.errors.totalRoomSize)
                          }
                          helperText={
                            formik.touched.totalRoomSize &&
                            formik.errors.totalRoomSize
                          }
                          placeholder="Enter room size"
                          size="medium"
                        />
                      </Grid>
                    )}

                    {formik.values.gameType === "playForFun" ? null : (
                      <Grid item xs={12} md={6}>
                        <TextField
                          fullWidth
                          label="No. of Winners"
                          name="numberOfWinners"
                          disabled={true}
                          value={
                            formik.values.type == "head-to-head"
                              ? 1
                              : formik.values.numberOfWinners
                          }
                          onChange={(e) => {
                            const value = e.target.value
                              .replace(/[^0-9]/g, "")
                              .slice(0, 9);
                            formik.setFieldValue("numberOfWinners", value);
                          }}
                          error={
                            formik.touched.numberOfWinners &&
                            Boolean(formik.errors.numberOfWinners)
                          }
                          helperText={
                            formik.touched.numberOfWinners &&
                            formik.errors.numberOfWinners
                          }
                          placeholder="Enter number of winners"
                          size="medium"
                        />
                      </Grid>
                    )}
                  </Grid>
                </Paper>

                {/* Game Rules */}
                <Paper
                  elevation={0}
                  sx={{
                    p: 3,
                    border: "1px solid",
                    borderColor: "divider",
                    borderRadius: 2,
                  }}
                >
                  <Box display="flex" alignItems="center" gap={2} mb={3}>
                    <SportsSoccer sx={{ color: "primary.main" }} />
                    <Typography variant="h6" fontWeight="600">
                      Game Type
                    </Typography>
                  </Box>

                  <Grid container spacing={3}>
                    <Grid item xs={12}>
                      <TextField
                        select
                        fullWidth
                        label="Game Type"
                        name="contestType.type"
                        value={formik.values.contestType.type}
                        error={
                          formik.touched.contestType?.type &&
                          Boolean(formik.errors.contestType?.type)
                        }
                        helperText={
                          formik.touched.contestType?.type &&
                          formik.errors.contestType?.type
                        }
                        onChange={(e) => {
                          const value = e.target.value;
                          formik.setValues({
                            ...formik.values,
                            contestType: {
                              type: value,
                              playerPosition:
                                value === "position"
                                  ? formik.values.contestType.playerPosition
                                  : "",
                              actionType:
                                value === "action"
                                  ? formik.values.contestType.actionType
                                  : "",
                            },
                          });
                        }}
                        size="medium"
                        disabled={true}
                      >
                        {(formik.values.timeRange !== "daily" ||
                          matchCount > 1) && [
                          <MenuItem key="standard" value="standard">
                            Standard
                          </MenuItem>,
                          <MenuItem
                            key="unlimited-budget"
                            value="unlimited-budget"
                          >
                            Unlimited Budget
                          </MenuItem>,
                          <MenuItem key="negative-point" value="negative-point">
                            Negative Points
                          </MenuItem>,
                        ]}
                        <MenuItem value="position">Position</MenuItem>
                        <MenuItem value="action">Action</MenuItem>
                      </TextField>
                    </Grid>

                    {formik.values.contestType.type === "negative-point" && (
                      <Grid item xs={12}>
                        <TextField
                          select
                          fullWidth
                          label="Negative Type"
                          name="contestType.negativeType"
                          value={formik.values.contestType.negativeType}
                          onChange={formik.handleChange}
                          error={
                            formik.touched.contestType?.negativeType &&
                            Boolean(formik.errors.contestType?.negativeType)
                          }
                          helperText={
                            formik.touched.contestType?.negativeType &&
                            formik.errors.contestType?.negativeType
                          }
                          size="medium"
                          disabled={true}
                        >
                          <MenuItem value="goals">Goals</MenuItem>
                          <MenuItem value="assists">Assists</MenuItem>
                          <MenuItem value="cleanSheet">Clean Sheet</MenuItem>
                        </TextField>
                      </Grid>
                    )}

                    {(formik.values.contestType.type === "position" ||
                      formik.values.contestType.type === "action") && (
                      <Grid item xs={12}>
                        <TextField
                          select
                          fullWidth
                          label="Players Position"
                          name="contestType.playerPosition"
                          value={formik.values.contestType.playerPosition}
                          onChange={formik.handleChange}
                          error={
                            formik.touched.contestType?.playerPosition &&
                            Boolean(formik.errors.contestType?.playerPosition)
                          }
                          helperText={
                            formik.touched.contestType?.playerPosition &&
                            formik.errors.contestType?.playerPosition
                          }
                          size="medium"
                          disabled={true}
                        >
                          <MenuItem value="27">Forward</MenuItem>
                          <MenuItem value="26">Midfielder</MenuItem>
                          <MenuItem value="25">Defender</MenuItem>
                          <MenuItem value="24">Goalkeeper</MenuItem>
                        </TextField>
                      </Grid>
                    )}

                    {formik?.values?.contestType?.playerPosition &&
                      formik.values.contestType.type === "action" && (
                        <Grid item xs={12}>
                          <TextField
                            select
                            fullWidth
                            label="Action"
                            name="contestType.playerActionType"
                            value={formik.values.contestType.playerActionType}
                            onChange={formik.handleChange}
                            error={
                              formik.touched.contestType?.playerActionType &&
                              Boolean(
                                formik.errors.contestType?.playerActionType
                              )
                            }
                            helperText={
                              formik.touched.contestType?.playerActionType &&
                              formik.errors.contestType?.playerActionType
                            }
                            size="medium"
                            disabled={true}
                          >
                            {positionActionsMap[
                              formik?.values?.contestType?.playerPosition
                            ]?.map((action, index) => (
                              <MenuItem key={index} value={action.value}>
                                {action.label}
                              </MenuItem>
                            ))}
                          </TextField>
                        </Grid>
                      )}
                  </Grid>
                </Paper>

                {/* Financial Configuration */}
                {formik.values.gameType !== "playForFun" && (
                  <Paper
                    elevation={0}
                    sx={{
                      p: 3,
                      border: "1px solid",
                      borderColor: "divider",
                      borderRadius: 2,
                    }}
                  >
                    <Box display="flex" alignItems="center" gap={2} mb={3}>
                      <AttachMoney sx={{ color: "primary.main" }} />
                      <Typography variant="h6" fontWeight="600">
                        Financial Configuration
                      </Typography>
                    </Box>

                    <Grid container spacing={3}>
                      <Grid item xs={12} md={6}>
                        <TextField
                          fullWidth
                          label="Entry Fees"
                          name="entryFee"
                          value={
                            formik.values.entryFee
                              ? formatPrice(formik.values.entryFee)
                              : ""
                          }
                          onChange={(e) => {
                            let value = e.target.value;
                            value = value.replace(/[^0-9.]/g, "");
                            if (value.indexOf(".") !== -1) {
                              const parts = value.split(".");
                              if (parts[1]?.length > 2) {
                                value = `${parts[0]}.${parts[1].slice(0, 2)}`;
                              }
                            }

                            if (value.replace(".", "").length > 7) {
                              value = value.slice(
                                0,
                                value.indexOf(".") !== -1
                                  ? value.indexOf(".") + 3
                                  : 7
                              );
                            }

                            formik.setFieldValue("entryFee", value);
                          }}
                          error={
                            formik.touched.entryFee &&
                            Boolean(formik.errors.entryFee)
                          }
                          helperText={
                            formik.touched.entryFee && formik.errors.entryFee
                          }
                          placeholder="0.00"
                          size="medium"
                          disabled={true}
                        />
                      </Grid>

                      <Grid item xs={12} md={6}>
                        <TextField
                          fullWidth
                          label="Entry Commission"
                          name="contestCommission"
                          value={
                            formik.values.contestCommission
                              ? formatPrice(formik.values.contestCommission)
                              : ""
                          }
                          InputLabelProps={{ shrink: true }}
                          onChange={(e) => {
                            let value = e.target.value;
                            value = value.replace(/[^0-9.]/g, "");
                            if (value.indexOf(".") !== -1) {
                              const parts = value.split(".");
                              if (parts[1]?.length > 2) {
                                value = `${parts[0]}.${parts[1].slice(0, 2)}`;
                              }
                            }

                            if (value.replace(".", "").length > 7) {
                              value = value.slice(
                                0,
                                value.indexOf(".") !== -1
                                  ? value.indexOf(".") + 3
                                  : 7
                              );
                            }

                            formik.setFieldValue("contestCommission", value);
                          }}
                          onBlur={formik.handleBlur}
                          error={
                            formik.touched.contestCommission &&
                            Boolean(formik.errors.contestCommission)
                          }
                          helperText={
                            formik.touched.contestCommission &&
                            formik.errors.contestCommission
                          }
                          placeholder="0.00"
                          size="medium"
                          disabled={true}
                        />
                      </Grid>
                    </Grid>
                  </Paper>
                )}

                {/* Payout Structure */}
                {formik.values.gameType !== "playForFun" &&
                  formik.values.type != "head-to-head" && (
                    <Paper
                      elevation={0}
                      sx={{
                        p: 3,
                        border: "1px solid",
                        borderColor: "divider",
                        borderRadius: 2,
                      }}
                    >
                      <Box display="flex" alignItems="center" gap={2} mb={3}>
                        <EmojiEvents sx={{ color: "primary.main" }} />
                        <Typography variant="h6" fontWeight="600">
                          Payout Structure
                        </Typography>
                      </Box>

                      <Box mb={3}>
                        <Alert severity="info" sx={{ mb: 2 }}>
                          Configure the winning structure and percentage
                          distribution for contest participants.
                        </Alert>
                      </Box>

                      <FieldArray
                        name="payoutStructure"
                        render={(arrayHelpers) => (
                          <Box>
                            {formik.values.payoutStructure.map(
                              (item, index) => (
                                <Card
                                  key={index}
                                  sx={{
                                    mb: 2,
                                    border: "1px solid",
                                    borderColor: "divider",
                                  }}
                                >
                                  <CardContentInner sx={{ p: 2 }}>
                                    <Grid
                                      container
                                      spacing={2}
                                      alignItems="center"
                                    >
                                      <Grid item xs={12} sm={3}>
                                        <TextField
                                          fullWidth
                                          label="Winner Start No."
                                          name={`payoutStructure.${index}.startPosition`}
                                          value={item.startPosition}
                                          onChange={(e) => {
                                            const value =
                                              e.target.value.replace(
                                                /[^0-9]/g,
                                                ""
                                              );
                                            formik.setFieldValue(
                                              `payoutStructure.${index}.startPosition`,
                                              value
                                            );
                                          }}
                                          error={
                                            formik.touched.payoutStructure?.[
                                              index
                                            ]?.startPosition &&
                                            Boolean(
                                              formik.errors.payoutStructure?.[
                                                index
                                              ]?.startPosition
                                            )
                                          }
                                          helperText={
                                            formik.touched.payoutStructure?.[
                                              index
                                            ]?.startPosition &&
                                            formik.errors.payoutStructure?.[
                                              index
                                            ]?.startPosition
                                          }
                                          size="small"
                                          disabled={true}
                                        />
                                      </Grid>
                                      <Grid item xs={12} sm={3}>
                                        <TextField
                                          fullWidth
                                          label="Winner End No."
                                          name={`payoutStructure.${index}.endPosition`}
                                          value={item.endPosition}
                                          onChange={(e) => {
                                            const value =
                                              e.target.value.replace(
                                                /[^0-9]/g,
                                                ""
                                              );
                                            formik.setFieldValue(
                                              `payoutStructure.${index}.endPosition`,
                                              value
                                            );
                                          }}
                                          error={
                                            formik.touched.payoutStructure?.[
                                              index
                                            ]?.endPosition &&
                                            Boolean(
                                              formik.errors.payoutStructure?.[
                                                index
                                              ]?.endPosition
                                            )
                                          }
                                          helperText={
                                            formik.touched.payoutStructure?.[
                                              index
                                            ]?.endPosition &&
                                            formik.errors.payoutStructure?.[
                                              index
                                            ]?.endPosition
                                          }
                                          size="small"
                                          disabled={true}
                                        />
                                      </Grid>
                                      <Grid item xs={12} sm={3}>
                                        <TextField
                                          fullWidth
                                          label="Winning %"
                                          name={`payoutStructure.${index}.percentage`}
                                          value={item.percentage}
                                          onChange={(e) => {
                                            const value = e.target.value;
                                            if (/^\d*\.?\d{0,2}$/.test(value)) {
                                              const updatedStructure = [
                                                ...formik.values
                                                  .payoutStructure,
                                              ];
                                              updatedStructure[
                                                index
                                              ].percentage = value;
                                              const total =
                                                updatedStructure.reduce(
                                                  (sum, item) =>
                                                    sum +
                                                    Number(
                                                      item.percentage || 0
                                                    ),
                                                  0
                                                );
                                              if (total > 100) {
                                                setPercentageErrorIndex(index);
                                              } else {
                                                setPercentageErrorIndex(null);
                                              }
                                              formik.setFieldValue(
                                                "payoutStructure",
                                                updatedStructure
                                              );
                                            }
                                          }}
                                          error={
                                            (formik.touched.payoutStructure?.[
                                              index
                                            ]?.percentage &&
                                              Boolean(
                                                formik.errors.payoutStructure?.[
                                                  index
                                                ]?.percentage
                                              )) ||
                                            percentageErrorIndex === index
                                          }
                                          helperText={
                                            formik.touched.payoutStructure?.[
                                              index
                                            ]?.percentage &&
                                            formik.errors.payoutStructure?.[
                                              index
                                            ]?.percentage
                                              ? formik.errors.payoutStructure[
                                                  index
                                                ].percentage
                                              : percentageErrorIndex === index
                                              ? "Total payout percentage cannot exceed 100%"
                                              : ""
                                          }
                                          size="small"
                                          disabled={true}
                                        />
                                      </Grid>

                                      <Grid
                                        item
                                        xs={12}
                                        sm={3}
                                        display="flex"
                                        alignItems="center"
                                        gap={1}
                                      >
                                        {/* Add/Remove buttons disabled for view mode */}
                                      </Grid>
                                    </Grid>
                                  </CardContentInner>
                                </Card>
                              )
                            )}
                          </Box>
                        )}
                      />

                      <Box mt={2}>
                        <Chip
                          label={`Total Percentage: ${
                            getRemainingPercentage() === 0
                              ? "100%"
                              : `${100 - getRemainingPercentage()}%`
                          }`}
                          color={
                            getRemainingPercentage() === 0
                              ? "success"
                              : "warning"
                          }
                          variant="outlined"
                          size="medium"
                        />
                        {getRemainingPercentage() !== 0 && (
                          <Typography
                            variant="body2"
                            color="warning.main"
                            mt={1}
                          >
                            Remaining: {getRemainingPercentage()}%
                          </Typography>
                        )}
                      </Box>

                      <Grid item xs={12}>
                        {formik.errors.payoutStructure &&
                          typeof formik.errors.payoutStructure === "string" && (
                            <FormHelperText error>
                              {formik.errors.payoutStructure}
                            </FormHelperText>
                          )}
                      </Grid>
                    </Paper>
                  )}

                {/* Time Configuration */}
                <Paper
                  elevation={0}
                  sx={{
                    p: 3,
                    border: "1px solid",
                    borderColor: "divider",
                    borderRadius: 2,
                  }}
                >
                  <Box display="flex" alignItems="center" gap={2} mb={3}>
                    <Schedule sx={{ color: "primary.main" }} />
                    <Typography variant="h6" fontWeight="600">
                      Time Configuration
                    </Typography>
                  </Box>

                  <Grid container spacing={3}>
                    <Grid item xs={12}>
                      <TextField
                        select
                        fullWidth
                        label="Game Period"
                        name="timeRange"
                        value={formik.values.timeRange}
                        onChange={handleTimeRangeChange}
                        error={
                          formik.touched.timeRange &&
                          Boolean(formik.errors.timeRange)
                        }
                        helperText={
                          formik.touched.timeRange && formik.errors.timeRange
                        }
                        size="medium"
                        disabled={true}
                      >
                        <MenuItem value="daily">Daily</MenuItem>
                        <MenuItem value="week">Weekly</MenuItem>
                        <MenuItem value="monthly">Monthly</MenuItem>
                        <MenuItem value="season">Season</MenuItem>
                      </TextField>
                    </Grid>

                    {["season", "daily", "week", "monthly"].includes(
                      formik?.values?.timeRange
                    ) && (
                      <LocalizationProvider dateAdapter={AdapterDateFns}>
                        <Grid
                          item
                          xs={formik?.values?.timeRange === "daily" ? 12 : 6}
                        >
                          <DatePicker
                            label="Start Date"
                            className="CustomCalenderbox"
                            format="dd/MM/yyyy"
                            value={
                              formik.values.startTime
                                ? new Date(formik.values.startTime)
                                : null
                            }
                            onChange={(date) => {
                              try {
                                if (
                                  date &&
                                  date instanceof Date &&
                                  !isNaN(date.getTime())
                                ) {
                                  const start = new Date(date);
                                  start.setHours(0, 0, 0, 0);
                                  const isoStart = start.toISOString();
                                  formik.setFieldValue("startTime", isoStart);

                                  if (formik.values.timeRange === "daily") {
                                    const end = new Date(date);
                                    end.setHours(23, 59, 59, 999);
                                    const isoEnd = end.toISOString();
                                    formik.setFieldValue("endTime", isoEnd);

                                    if (formik.values.leagueId) {
                                      setTimeout(
                                        () => callCountMatchTimeWise(),
                                        100
                                      );
                                    }
                                  }
                                } else {
                                  formik.setFieldValue("startTime", "");
                                  if (formik.values.timeRange === "daily") {
                                    formik.setFieldValue("endTime", "");
                                  }
                                }
                              } catch (error) {
                                console.error(
                                  "Error handling start date change:",
                                  error
                                );
                                formik.setFieldValue("startTime", "");
                                if (formik.values.timeRange === "daily") {
                                  formik.setFieldValue("endTime", "");
                                }
                              }
                            }}
                            slots={{
                              textField: (params) => (
                                <TextField
                                  {...params}
                                  name="startTime"
                                  error={
                                    formik.touched.startTime &&
                                    Boolean(formik.errors.startTime)
                                  }
                                  helperText={formik.touched.startTime}
                                  fullWidth
                                  size="medium"
                                  disabled={true}
                                />
                              ),
                            }}
                          />
                          <FormHelperText error>
                            {formik.errors.startTime}
                          </FormHelperText>
                        </Grid>

                        {formik?.values?.timeRange !== "daily" && (
                          <Grid item xs={6}>
                            <DatePicker
                              label="End Date"
                              className="CustomCalenderbox"
                              format="dd/MM/yyyy"
                              value={
                                formik.values.endTime
                                  ? new Date(formik.values.endTime)
                                  : null
                              }
                              error={
                                formik.touched.endTime &&
                                Boolean(formik.errors.endTime)
                              }
                              helperText={
                                formik.touched.endTime && formik.errors.endTime
                              }
                              onChange={(date) => {
                                try {
                                  if (
                                    date &&
                                    date instanceof Date &&
                                    !isNaN(date.getTime())
                                  ) {
                                    const end = new Date(date);
                                    end.setHours(23, 59, 59, 999);
                                    const isoEnd = end.toISOString();
                                    formik.setFieldValue("endTime", isoEnd);
                                  } else {
                                    formik.setFieldValue("endTime", "");
                                  }
                                } catch (error) {
                                  console.error(
                                    "Error handling end date change:",
                                    error
                                  );
                                  formik.setFieldValue("endTime", "");
                                }
                              }}
                              slots={{
                                textField: (params) => (
                                  <TextField
                                    {...params}
                                    name="endTime"
                                    error={
                                      formik.touched.endTime &&
                                      Boolean(formik.errors.endTime)
                                    }
                                    required
                                    fullWidth
                                    size="medium"
                                    disabled={true}
                                  />
                                ),
                              }}
                            />
                            <FormHelperText error>
                              {formik.errors.endTime}
                            </FormHelperText>
                          </Grid>
                        )}
                      </LocalizationProvider>
                    )}
                  </Grid>
                </Paper>

                {/* Match Selection Section */}
                {formik.values.timeRange &&
                  formik.values.startTime &&
                  formik.values.endTime && (
                    <Paper
                      elevation={0}
                      sx={{
                        p: 3,
                        border: "1px solid",
                        borderColor: "divider",
                        borderRadius: 2,
                      }}
                    >
                      <Box display="flex" alignItems="center" gap={2} mb={3}>
                        <SportsSoccer sx={{ color: "primary.main" }} />
                        <Typography variant="h6" fontWeight="600">
                          Match Selection
                        </Typography>
                      </Box>

                      <Box className="match-selection-container">
                        <div className="match-content">
                          {/* Daily Matches Tab */}
                          {formik.values.timeRange === "daily" && (
                            <div className="tab-pane active daily-matches">
                              <div className="tab-header">
                                <div className="tab-header-top">
                                  <h6>
                                    Daily Matches -{" "}
                                    {formik.values.startTime
                                      ? new Date(
                                          formik.values.startTime
                                        ).toLocaleDateString("en-GB", {
                                          year: "numeric",
                                          month: "short",
                                          day: "numeric",
                                        })
                                      : ""}
                                  </h6>
                                  <span className="match-count">
                                    {availableMatches.length} matches available
                                  </span>
                                </div>
                              </div>
                              <div className="match-list">
                                {availableMatches.length > 0 ? (
                                  availableMatches?.map((match) => {
                                    const homeTeam = match.participants?.find(
                                      (p) => p.meta?.location === "home"
                                    ) || {
                                      name:
                                        match.name?.split(" vs ")[0] ||
                                        "Team A",
                                    };
                                    const awayTeam = match.participants?.find(
                                      (p) => p.meta?.location === "away"
                                    ) || {
                                      name:
                                        match.name?.split(" vs ")[1] ||
                                        "Team B",
                                    };
                                    const matchDate = new Date(
                                      match.startingAt
                                    ).toLocaleDateString("en-GB", {
                                      weekday: "long",
                                      month: "short",
                                      day: "numeric",
                                    });
                                    const matchTime = new Date(
                                      match.startingAt
                                    ).toLocaleTimeString([], {
                                      hour: "2-digit",
                                      minute: "2-digit",
                                    });
                                    const statusText =
                                      match.status === 1
                                        ? "Scheduled"
                                        : match.liveStats?.status === "live"
                                        ? "Live"
                                        : "Completed";
                                    const statusClass =
                                      match.status === 1
                                        ? "status-1"
                                        : match.liveStats?.status === "live"
                                        ? "status-live"
                                        : "status-2";

                                    return (
                                      <div
                                        key={match._id}
                                        className={`match-item ${
                                          isMatchSelected(match._id, "daily")
                                            ? "selected"
                                            : ""
                                        }`}
                                        style={{
                                          cursor: "default",
                                          opacity: 0.8,
                                        }}
                                        title="Match selection disabled in view mode"
                                      >
                                        <div className="match-teams">
                                          <img
                                            src={
                                              homeTeam?.imagePath ||
                                              "/images/default-team.png"
                                            }
                                            alt={homeTeam?.name}
                                          />
                                          <span>{homeTeam?.name}</span>
                                        </div>
                                        <div className="match-details">
                                          <div className="match-date">
                                            {matchDate}
                                          </div>
                                          <div className="match-time">
                                            {matchTime}
                                          </div>
                                        </div>
                                        <div className="match-teams">
                                          <span>{awayTeam?.name}</span>
                                          <img
                                            src={
                                              awayTeam?.imagePath ||
                                              "/images/default-team.png"
                                            }
                                            alt={awayTeam?.name}
                                          />
                                        </div>
                                      </div>
                                    );
                                  })
                                ) : (
                                  <div className="no-matches">
                                    <p>
                                      No matches available for the selected
                                      date.
                                    </p>
                                  </div>
                                )}
                              </div>
                            </div>
                          )}

                          {/* Weekly Matches Tab */}
                          {formik.values.timeRange === "week" && (
                            <div className="tab-pane active">
                              {(() => {
                                const weeks = availableMatches;
                                const weekKeys = weeks.map((r) => r.uiKey);

                                return (
                                  <>
                                    <div className="tab-header">
                                      <div className="tab-header-top">
                                        <h6>Weekly Matches</h6>
                                        <span className="match-count">
                                          {weekKeys.length} rounds available
                                        </span>
                                      </div>
                                    </div>
                                    {weekKeys.length > 0 ? (
                                      <>
                                        <div className="week-tabs">
                                          <div className="week-tabs-header">
                                            <span className="week-tabs-title">
                                              Game Weeks
                                            </span>
                                          </div>
                                          <div className="week-tabs-grid">
                                            {weeks.map((round, index) => {
                                              const actualWeekNumber =
                                                round.roundNumber || index + 1;
                                              return (
                                                <button
                                                  type="button"
                                                  key={round.uiKey}
                                                  className={`week-tab ${
                                                    activeWeekTab ===
                                                    actualWeekNumber
                                                      ? "active"
                                                      : ""
                                                  }`}
                                                  onClick={() =>
                                                    setActiveWeekTab(
                                                      actualWeekNumber
                                                    )
                                                  }
                                                  title="Click to view this game week"
                                                >
                                                  <span className="week-number">
                                                    Round {round.roundName || actualWeekNumber}
                                                  </span>
                                                  <span className="week-dates">
                                                    {round.startDate.toLocaleDateString()}{" "}
                                                    -{" "}
                                                    {round.endDate.toLocaleDateString()}
                                                  </span>
                                                  {(round.matches?.length || 0) === 0 && (
                                                    <span className="week-status">No Matches</span>
                                                  )}
                                                </button>
                                              );
                                            })}
                                          </div>
                                        </div>

                                        {weeks.map((round, index) => {
                                          const actualWeekNumber = round.roundNumber || index + 1;
                                          return (
                                            <div
                                              key={round.uiKey}
                                              className={`week-content ${
                                                weeks.length === 1 ||
                                                activeWeekTab ===
                                                  actualWeekNumber
                                                  ? "active"
                                                  : ""
                                              }`}
                                            >
                                              <div className="week-header">
                                                <div className="week-header-top">
                                                  <h6>
                                                    {weeks.length === 1
                                                      ? "Weekly Matches"
                                                      : `Game Week ${round.roundName || actualWeekNumber} Matches`}
                                                  </h6>
                                                  <span className="match-count">
                                                    {round.matches?.length || 0}{" "}
                                                    matches
                                                  </span>
                                                </div>
                                              </div>
                                              <div className="match-list">
                                                {round.matches?.length > 0 ? (
                                                  round.matches.map(
                                                    (match) => {
                                                      const homeTeam =
                                                        match.participants?.find(
                                                          (p) =>
                                                            p.meta?.location ===
                                                            "home"
                                                        ) || {
                                                          name:
                                                            match.name?.split(
                                                              " vs "
                                                            )[0] || "Team A",
                                                        };
                                                      const awayTeam =
                                                        match.participants?.find(
                                                          (p) =>
                                                            p.meta?.location ===
                                                            "away"
                                                        ) || {
                                                          name:
                                                            match.name?.split(
                                                              " vs "
                                                            )[1] || "Team B",
                                                        };
                                                      const matchDate =
                                                        new Date(
                                                          match.startingAt
                                                        ).toLocaleDateString(
                                                          "en-GB",
                                                          {
                                                            weekday: "long",
                                                            month: "short",
                                                            day: "numeric",
                                                          }
                                                        );
                                                      const matchTime =
                                                        new Date(
                                                          match.startingAt
                                                        ).toLocaleTimeString(
                                                          "en-GB",
                                                          {
                                                            hour: "2-digit",
                                                            minute: "2-digit",
                                                            hour12: false,
                                                          }
                                                        );

                                                      return (
                                                        <div
                                                          key={match._id}
                                                          className={`match-item ${
                                                            isMatchSelected(
                                                              match._id,
                                                              "weekly",
                                                              round.uiKey
                                                            )
                                                              ? "selected"
                                                              : ""
                                                          }`}
                                                          style={{
                                                            cursor: "default",
                                                            opacity: 0.8,
                                                          }}
                                                          title="Match selection disabled in view mode"
                                                        >
                                                          <div className="match-teams">
                                                            <img
                                                              src={
                                                                homeTeam?.imagePath ||
                                                                "/images/default-team.png"
                                                              }
                                                              alt={
                                                                homeTeam?.name
                                                              }
                                                            />
                                                            <span>
                                                              {homeTeam?.name}
                                                            </span>
                                                          </div>
                                                          <div className="match-details">
                                                            <div className="match-date">
                                                              {matchDate}
                                                            </div>
                                                            <div className="match-time">
                                                              {matchTime}
                                                            </div>
                                                          </div>
                                                          <div className="match-teams">
                                                            <span>
                                                              {awayTeam?.name}
                                                            </span>
                                                            <img
                                                              src={
                                                                awayTeam?.imagePath ||
                                                                "/images/default-team.png"
                                                              }
                                                              alt={
                                                                awayTeam?.name
                                                              }
                                                            />
                                                          </div>
                                                        </div>
                                                      );
                                                    }
                                                  )
                                                ) : (
                                                  <div className="no-matches">
                                                    <p>
                                                      No matches available for
                                                      this game week.
                                                    </p>
                                                  </div>
                                                )}
                                              </div>
                                            </div>
                                          );
                                        })}
                                      </>
                                    ) : (
                                      <div className="no-matches">
                                        <p>
                                          No matches available for the selected
                                          week.
                                        </p>
                                      </div>
                                    )}
                                  </>
                                );
                              })()}
                            </div>
                          )}

                          {formik.values.timeRange === "monthly" && (
                            <div className="tab-pane active">
                              {(() => {
                                const weeks = availableMatches;
                                const weekKeys = weeks.map((r) => r.uiKey);

                                return (
                                  <>
                                    <div className="tab-header">
                                      <div className="tab-header-top">
                                        <h6>Monthly Matches</h6>
                                        <span className="match-count">
                                          {weekKeys.length} rounds available
                                        </span>
                                      </div>
                                    </div>
                                    {weekKeys.length > 0 ? (
                                      <>
                                        <div className="week-tabs">
                                          <div className="week-tabs-header">
                                            <span className="week-tabs-title">
                                              Game Weeks
                                            </span>
                                          </div>
                                          <div className="week-tabs-grid">
                                            {weeks.map((round, index) => {
                                              const actualWeekNumber =
                                                round.roundNumber || index + 1;
                                              return (
                                                <button
                                                  type="button"
                                                  key={round.uiKey}
                                                  className={`week-tab ${
                                                    activeWeekTab ===
                                                    actualWeekNumber
                                                      ? "active"
                                                      : ""
                                                  }`}
                                                  onClick={() =>
                                                    setActiveWeekTab(
                                                      actualWeekNumber
                                                    )
                                                  }
                                                  title="Click to view this game week"
                                                >
                                                  <span className="week-number">
                                                    Game Week {round.roundName || actualWeekNumber}
                                                  </span>
                                                  <span className="week-dates">
                                                    {round.startDate.toLocaleDateString()}{" "}
                                                    -{" "}
                                                    {round.endDate.toLocaleDateString()}
                                                  </span>
                                                  {(round.matches?.length || 0) === 0 && (
                                                    <span className="week-status">No Matches</span>
                                                  )}
                                                </button>
                                              );
                                            })}
                                          </div>
                                        </div>

                                        {weeks.map((round, index) => {
                                          const actualWeekNumber = round.roundNumber || index + 1;
                                          return (
                                            <div
                                              key={round.uiKey}
                                              className={`week-content ${
                                                weeks.length === 1 ||
                                                activeWeekTab ===
                                                  actualWeekNumber
                                                  ? "active"
                                                  : ""
                                              }`}
                                            >
                                              <div className="week-header">
                                                <div className="week-header-top">
                                                  <h6>
                                                    {weeks.length === 1
                                                      ? "Monthly Matches"
                                                      : `Game Week ${round.roundName || actualWeekNumber} Matches`}
                                                  </h6>
                                                  <span className="match-count">
                                                    {round.matches?.length || 0}{" "}
                                                    matches
                                                  </span>
                                                </div>
                                              </div>
                                              <div className="match-list">
                                                {round.matches?.length > 0 ? (
                                                  round.matches.map(
                                                    (match) => {
                                                      const homeTeam =
                                                        match.participants?.find(
                                                          (p) =>
                                                            p.meta?.location ===
                                                            "home"
                                                        ) || {
                                                          name:
                                                            match.name?.split(
                                                              " vs "
                                                            )[0] || "Team A",
                                                        };
                                                      const awayTeam =
                                                        match.participants?.find(
                                                          (p) =>
                                                            p.meta?.location ===
                                                            "away"
                                                        ) || {
                                                          name:
                                                            match.name?.split(
                                                              " vs "
                                                            )[1] || "Team B",
                                                        };
                                                      const matchDate =
                                                        new Date(
                                                          match.startingAt
                                                        ).toLocaleDateString(
                                                          "en-GB",
                                                          {
                                                            weekday: "long",
                                                            month: "short",
                                                            day: "numeric",
                                                          }
                                                        );
                                                      const matchTime =
                                                        new Date(
                                                          match.startingAt
                                                        ).toLocaleTimeString(
                                                          "en-GB",
                                                          {
                                                            hour: "2-digit",
                                                            minute: "2-digit",
                                                            hour12: false,
                                                          }
                                                        );

                                                      return (
                                                        <div
                                                          key={match._id}
                                                          className={`match-item ${
                                                            isMatchSelected(
                                                              match._id,
                                                              "monthly",
                                                              round.uiKey
                                                            )
                                                              ? "selected"
                                                              : ""
                                                          }`}
                                                          style={{
                                                            cursor: "default",
                                                            opacity: 0.8,
                                                          }}
                                                          title="Match selection disabled in view mode"
                                                        >
                                                          <div className="match-teams">
                                                            <img
                                                              src={
                                                                homeTeam?.imagePath ||
                                                                "/images/default-team.png"
                                                              }
                                                              alt={
                                                                homeTeam?.name
                                                              }
                                                            />
                                                            <span>
                                                              {homeTeam?.name}
                                                            </span>
                                                          </div>
                                                          <div className="match-details">
                                                            <div className="match-date">
                                                              {matchDate}
                                                            </div>
                                                            <div className="match-time">
                                                              {matchTime}
                                                            </div>
                                                          </div>
                                                          <div className="match-teams team2">
                                                            <span>
                                                              {awayTeam?.name}
                                                            </span>
                                                            <img
                                                              src={
                                                                awayTeam?.imagePath ||
                                                                "/images/default-team.png"
                                                              }
                                                              alt={
                                                                awayTeam?.name
                                                              }
                                                            />
                                                          </div>
                                                        </div>
                                                      );
                                                    }
                                                  )
                                                ) : (
                                                  <div className="no-matches">
                                                    <p>
                                                      No matches available for
                                                      this game week.
                                                    </p>
                                                  </div>
                                                )}
                                              </div>
                                            </div>
                                          );
                                        })}
                                      </>
                                    ) : (
                                      <div className="no-matches">
                                        <p>
                                          No matches available for the selected
                                          month.
                                        </p>
                                      </div>
                                    )}
                                  </>
                                );
                              })()}
                            </div>
                          )}

                          {/* Season Matches Tab */}
                          {formik.values.timeRange === "season" && (
                            <div className="tab-pane active">
                              {(() => {
                                const weeks = availableMatches;
                                const weekKeys = weeks.map((r) => r.uiKey);

                                return (
                                  <>
                                    <div className="tab-header">
                                      <div className="tab-header-top">
                                        <h6>Season Matches</h6>
                                        <span className="match-count">
                                          {weekKeys.length} rounds available
                                        </span>
                                      </div>
                                    </div>
                                    {weekKeys.length > 0 ? (
                                      <>
                                        <div className="week-tabs">
                                          <div className="week-tabs-header">
                                            <span className="week-tabs-title">
                                              Game Weeks
                                            </span>
                                          </div>
                                          <div className="week-tabs-grid">
                                            {weeks.map((round, index) => {
                                              const actualWeekNumber =
                                                round.roundNumber || index + 1;
                                              return (
                                                <button
                                                  type="button"
                                                  key={round.uiKey}
                                                  className={`week-tab ${
                                                    activeWeekTab ===
                                                    actualWeekNumber
                                                      ? "active"
                                                      : ""
                                                  }`}
                                                  onClick={() =>
                                                    setActiveWeekTab(
                                                      actualWeekNumber
                                                    )
                                                  }
                                                  title="Click to view this game week"
                                                >
                                                  <span className="week-number">
                                                    Round {round.roundName || actualWeekNumber}
                                                  </span>
                                                  <span className="week-dates">
                                                    {round.startDate.toLocaleDateString()}{" "}
                                                    -{" "}
                                                    {round.endDate.toLocaleDateString()}
                                                  </span>
                                                  {(round.matches?.length || 0) === 0 && (
                                                    <span className="week-status">No Matches</span>
                                                  )}
                                                </button>
                                              );
                                            })}
                                          </div>
                                        </div>

                                        {weeks.map((round, index) => {
                                          const actualWeekNumber = round.roundNumber || index + 1;
                                          return (
                                            <div
                                              key={round.uiKey}
                                              className={`week-content ${
                                                weeks.length === 1 ||
                                                activeWeekTab ===
                                                  actualWeekNumber
                                                  ? "active"
                                                  : ""
                                              }`}
                                            >
                                              <div className="week-header">
                                                <div className="week-header-top">
                                                  <h6>
                                                    {weeks.length === 1
                                                      ? "Season Matches"
                                                      : `Game Week ${round.roundName || actualWeekNumber} Matches`}
                                                  </h6>
                                                  <span className="match-count">
                                                    {round.matches?.length || 0}{" "}
                                                    matches
                                                  </span>
                                                </div>
                                              </div>
                                              <div className="match-list">
                                                {round.matches?.length > 0 ? (
                                                  round.matches.map(
                                                    (match) => {
                                                      const homeTeam =
                                                        match.participants?.find(
                                                          (p) =>
                                                            p.meta?.location ===
                                                            "home"
                                                        ) || {
                                                          name:
                                                            match.name?.split(
                                                              " vs "
                                                            )[0] || "Team A",
                                                        };
                                                      const awayTeam =
                                                        match.participants?.find(
                                                          (p) =>
                                                            p.meta?.location ===
                                                            "away"
                                                        ) || {
                                                          name:
                                                            match.name?.split(
                                                              " vs "
                                                            )[1] || "Team B",
                                                        };
                                                      const matchDate =
                                                        new Date(
                                                          match.startingAt
                                                        ).toLocaleDateString(
                                                          "en-GB",
                                                          {
                                                            weekday: "long",
                                                            month: "short",
                                                            day: "numeric",
                                                          }
                                                        );
                                                      const matchTime =
                                                        new Date(
                                                          match.startingAt
                                                        ).toLocaleTimeString(
                                                          "en-GB",
                                                          {
                                                            hour: "2-digit",
                                                            minute: "2-digit",
                                                            hour12: false,
                                                          }
                                                        );

                                                      return (
                                                        <div
                                                          key={match._id}
                                                          className={`match-item ${
                                                            isMatchSelected(
                                                              match._id,
                                                              "season",
                                                              round.uiKey
                                                            )
                                                              ? "selected"
                                                              : ""
                                                          }`}
                                                          style={{
                                                            cursor: "default",
                                                            opacity: 0.8,
                                                          }}
                                                          title="Match selection disabled in view mode"
                                                        >
                                                          <div className="match-teams">
                                                            <img
                                                              src={
                                                                homeTeam?.imagePath ||
                                                                "/images/default-team.png"
                                                              }
                                                              alt={
                                                                homeTeam?.name
                                                              }
                                                            />
                                                            <span>
                                                              {homeTeam?.name}
                                                            </span>
                                                          </div>
                                                          <div className="match-details">
                                                            <div className="match-date">
                                                              {matchDate}
                                                            </div>
                                                            <div className="match-time">
                                                              {matchTime}
                                                            </div>
                                                          </div>
                                                          <div className="match-teams">
                                                            <span>
                                                              {awayTeam?.name}
                                                            </span>
                                                            <img
                                                              src={
                                                                awayTeam?.imagePath ||
                                                                "/images/default-team.png"
                                                              }
                                                              alt={
                                                                awayTeam?.name
                                                              }
                                                            />
                                                          </div>
                                                        </div>
                                                      );
                                                    }
                                                  )
                                                ) : (
                                                  <div className="no-matches">
                                                    <p>
                                                      No matches available for
                                                      this game week.
                                                    </p>
                                                  </div>
                                                )}
                                              </div>
                                            </div>
                                          );
                                        })}
                                      </>
                                    ) : (
                                      <div className="no-matches">
                                        <p>
                                          No matches available for the selected
                                          season.
                                        </p>
                                      </div>
                                    )}
                                  </>
                                );
                              })()}
                            </div>
                          )}
                        </div>
                      </Box>
                    </Paper>
                  )}
              </Stack>
            </Form>
          </FormikProvider>
        </CardContent>
      </CardLayout>
    </Box>
  );
};

export default ViewAddEditContestManagement;
